import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';

import { showResult } from '../utils';

const api = (id: number) => `core-2/conversations/${id}/mark-assign`;

interface FnProps {
  conversationId: number;
  action: 'assign' | 'unassign';
}

const assignConversationFn = async ({ conversationId, action }: FnProps) => {
  const { data, error } = await dataService.updateOnly(api(conversationId), {
    action,
  });

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};

export const useAssignConversation = () => {
  const { mutateAsync, mutate, isLoading, ...other } = useMutation({
    mutationFn: assignConversationFn,
  });

  return {
    assignConversationAsync: mutateAsync,
    assignConversation: mutate,
    assignConversationLoading: isLoading,
    ...other,
  };
};
